/* eslint "indent": ["error", 4] */

const menu = document.getElementById('main-menu');
const main = document.getElementById('chipta-main');
const footer = document.getElementById('chipta-footer');
const items = document.querySelectorAll(".item");

// Toggle mobile menu
function toggleMenu() {
    if (smallScreen()) {
        if (['icon-hamburger', 'icon-cross'].includes(event.target.localName)) {
            menu.classList.toggle('active')
            main.classList.toggle('closed');
            footer.classList.toggle('closed');
        }
    }
}

let small = window.matchMedia("(max-width: 960px)")

function smallScreen() {
    if (small.matches) return true;
    return false;
}

// Event Listener
menu.addEventListener("click", toggleMenu, false);

// Activate Submenu
function toggleItem() {
    if (this.classList.contains("submenu-active")) {
        this.classList.remove("submenu-active");
    } else if (menu.querySelector(".submenu-active")) {
        menu.querySelector(".submenu-active").classList.remove("submenu-active");
        this.classList.add("submenu-active");
    } else {
        this.classList.add("submenu-active");
    }
}

// Event Listeners
for (let item of items) {
    if (item.querySelector(".submenu")) {
        item.addEventListener("click", toggleItem, false);
        item.addEventListener("keypress", toggleItem, false);
    }
}

// Close Submenu From Anywhere
function closeSubmenu(e) {
    if (menu.querySelector(".submenu-active")) {
        let isClickInside = menu.querySelector(".submenu-active").contains(e.target);
        if (!isClickInside && menu.querySelector(".submenu-active")) {
            menu.querySelector(".submenu-active").classList.remove("submenu-active");
        }
    }
}

// Event listener
document.addEventListener("click", closeSubmenu, false);
